import React from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { cloneDeep } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';

import {
  COST_FIELD_OPTS,
  USAGE_FIELD_OPTS,
  FIELD_NAME_RULE_OPTS,
} from './helpers';

const BOOLEAN_OPTS = {
  0: 'AND',
  1: 'OR',
};

const DEFAULT_CLAUSE = { field: 0, field_name: '', field_name_rule: 0 };

const styles = {
  cancelStyleR: {
    fontSize: '25px',
    lineHeight: 'inherit',
    color: 'red',
    cursor: 'pointer',
    padding: '6px 0px 0px 8px',
  },
  cancelStyleG: {
    fontSize: '25px',
    lineHeight: 'inherit',
    color: 'red',
    cursor: 'pointer',
    padding: '6px 0px 0px 8px',
  },
};

export default function PlugTemplateClauseGroup(props) {
  const {
    ruleType,
    clausesBoolen,
    setClausesBoolean,
    localClauses,
    setLocalClauses,
    clauseId,
    setClauseId,
  } = props;

  const addClause = () => {
    setLocalClauses((prev) => [
      ...prev,
      {
        id: clauseId,
        clause_type: 'simple',
        clause_data: DEFAULT_CLAUSE,
      },
    ]);
    setClauseId((prev) => prev + 1);
  };

  const addClauseGroup = () => {
    setLocalClauses((prev) => [
      ...prev,
      {
        id: clauseId,
        clause_type: 'group',
        clause_boolean: 0,
        clause_data: [],
      },
    ]);
    setClauseId((prev) => prev + 1);
  };

  const updateClause = (id, key, data) => {
    setLocalClauses((prev) =>
      prev.map((clause) => {
        if (clause['id'] !== id) return clause;
        let new_clause = cloneDeep(clause);
        new_clause['clause_data'][key] = data;
        return new_clause;
      })
    );
  };

  const removeClause = (id) => {
    setLocalClauses((prev) => prev.filter((clause) => clause.id !== id));
  };

  return (
    <>
      <div
        style={{
          border: 'solid 1px black',
          padding: '0.5em',
          margin: '1em',
          width: '100%',
        }}
      >
        <Row style={{ paddingLeft: '1em' }}>
          <Form style={{ width: '100px' }}>
            <Form.Control
              as='select'
              required
              value={clausesBoolen}
              onChange={(e) => setClausesBoolean(parseInt(e.target.value))}
            >
              {Object.keys(BOOLEAN_OPTS).map((opt) => (
                <option key={`name-rule-opt-${opt}`} value={opt}>
                  {BOOLEAN_OPTS[opt]}
                </option>
              ))}
            </Form.Control>
          </Form>
          <Button
            style={{ marginLeft: '0.5em' }}
            onClick={() => {
              addClause();
            }}
          >
            Add Rule
          </Button>
          <Button
            style={{ marginLeft: '0.5em' }}
            onClick={() => {
              addClauseGroup();
            }}
          >
            Add Group
          </Button>
        </Row>
        {localClauses.map((clause) => {
          return (
            <div key={clause.id}>
              {clause.clause_type === 'simple' && (
                <PlugTemplateClause
                  clause={clause}
                  ruleType={ruleType}
                  updateClause={updateClause}
                  handleRemoveClause={removeClause}
                />
              )}
              {clause.clause_type === 'group' && (
                <PlugTemplateClauseSubGroup
                  clause={clause}
                  ruleType={ruleType}
                  setLocalClauses={setLocalClauses}
                  clauseId={clauseId}
                  setClauseId={setClauseId}
                />
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}

function PlugTemplateClauseSubGroup(props) {
  const { clause, ruleType, setLocalClauses, clauseId, setClauseId } = props;

  const updateSubClause = (sub_id, key, value) => {
    setLocalClauses((prev) =>
      prev.map((cl) => {
        if (cl['id'] !== clause.id) return cl;
        cl['clause_data'] = cl['clause_data'].map((sub_cl) => {
          if (sub_cl['id'] !== sub_id) return sub_cl;
          let new_sub_cl = cloneDeep(sub_cl);
          new_sub_cl['clause_data'][key] = value;
          return new_sub_cl;
        });
        return cl;
      })
    );
  };

  const updateClauseBoolean = (id, value) => {
    setLocalClauses((prev) =>
      prev.map((cl) => {
        if (cl['id'] !== id) return cl;
        let new_cl = cloneDeep(cl);
        new_cl['clause_boolean'] = value;
        return new_cl;
      })
    );
  };

  const addSubClause = () => {
    setLocalClauses((prev) =>
      prev.map((cl) => {
        if (cl['id'] !== clause.id) return cl;
        cl['clause_data'] = [
          ...cl['clause_data'],
          {
            id: clauseId,
            clause_type: 'simple',
            clause_data: DEFAULT_CLAUSE,
          },
        ];
        return cl;
      })
    );
    setClauseId((prev) => prev + 1);
  };

  const removeClauseGroup = (id) => {
    setLocalClauses((prev) => prev.filter((cl) => cl.id !== id));
  };

  const removeClauseGroupClause = (id) => {
    setLocalClauses((prev) =>
      prev.map((cl) => {
        if (cl['id'] !== clause.id) return cl;
        cl['clause_data'] = cl['clause_data'].filter(
          (clause) => clause.id !== id
        );
        return cl;
      })
    );
  };

  return (
    <div
      style={{
        border: 'solid 1px black',
        padding: '0.5em',
        marginTop: '0.5em',
      }}
    >
      <Row style={{ paddingLeft: '1em' }}>
        <Form style={{ width: '100px' }}>
          <Form.Control
            as='select'
            required
            value={clause.clause_boolean}
            onChange={(e) =>
              updateClauseBoolean(clause.id, parseInt(e.target.value))
            }
          >
            {Object.keys(BOOLEAN_OPTS).map((opt) => (
              <option key={`name-rule-opt-${opt}`} value={opt}>
                {BOOLEAN_OPTS[opt]}
              </option>
            ))}
          </Form.Control>
        </Form>
        <Button
          style={{ marginLeft: '0.5em' }}
          onClick={() => {
            addSubClause();
          }}
        >
          Add Rule
        </Button>

        <FontAwesomeIcon
          style={styles.cancelStyleG}
          icon={faTimesCircle}
          onClick={() => removeClauseGroup(clause.id)}
        />
      </Row>
      {clause.clause_data.map((clause) => {
        return (
          <div key={clause.id}>
            <PlugTemplateClause
              clause={clause}
              ruleType={ruleType}
              updateClause={updateSubClause}
              handleRemoveClause={removeClauseGroupClause}
            />
          </div>
        );
      })}
    </div>
  );
}

function PlugTemplateClause(props) {
  const { clause, ruleType, updateClause, handleRemoveClause } = props;

  const LOCAL_OPTS = ruleType === 'usage' ? USAGE_FIELD_OPTS : COST_FIELD_OPTS;

  return (
    <div>
      <Row style={{ padding: '0.25em 0em 0.25em 1em' }}>
        <FontAwesomeIcon
          style={styles.cancelStyleR}
          icon={faTimesCircle}
          onClick={() => handleRemoveClause(clause.id)}
        />

        <Col>
          <Form style={{ width: '80%' }}>
            <Form.Control
              as='select'
              required
              value={clause.clause_data.field}
              onChange={(e) =>
                updateClause(clause.id, 'field', parseInt(e.target.value))
              }
            >
              {Object.keys(LOCAL_OPTS).map((opt) => (
                <option key={`field-name-opt-${opt}`} value={opt}>
                  {LOCAL_OPTS[opt]}
                </option>
              ))}
            </Form.Control>
          </Form>
        </Col>

        <Col>
          <Form style={{ width: '80%' }}>
            <Form.Control
              as='select'
              required
              value={clause.clause_data.field_name_rule}
              onChange={(e) =>
                updateClause(
                  clause.id,
                  'field_name_rule',
                  parseInt(e.target.value)
                )
              }
            >
              {Object.keys(FIELD_NAME_RULE_OPTS).map((opt) => (
                <option key={`field-name-rule-opt-${opt}`} value={opt}>
                  {FIELD_NAME_RULE_OPTS[opt]}
                </option>
              ))}
            </Form.Control>
          </Form>
        </Col>
        <Col>
          <Form style={{ width: '80%' }}>
            <Form.Control
              value={clause.clause_data.field_name}
              onChange={(e) =>
                updateClause(clause.id, 'field_name', e.target.value)
              }
            />
          </Form>
        </Col>
      </Row>
    </div>
  );
}
